"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestMembershipToJSON = exports.QuestMembershipFromJSONTyped = exports.QuestMembershipFromJSON = void 0;
function QuestMembershipFromJSON(json) {
    return QuestMembershipFromJSONTyped(json, false);
}
exports.QuestMembershipFromJSON = QuestMembershipFromJSON;
function QuestMembershipFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': json['userId'],
        'questConfigId': json['questConfigId'],
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}
exports.QuestMembershipFromJSONTyped = QuestMembershipFromJSONTyped;
function QuestMembershipToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'questConfigId': value.questConfigId,
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}
exports.QuestMembershipToJSON = QuestMembershipToJSON;
